export const enum CommonErrorCodes { 
    unknownError = 500,
    invalidStateError = 501,
    storageDisabled = 502,

    invalidSession = 401,
}